import type { DocumentPageMetadataUserEditComment } from 'features/knowledgeDocumentViewer/types/documentMetadataUserEditSchemas'

export function buildPageMetadataUserEditComment(args: {
  text: string
  createdBy: string
  createdAt: string
}): DocumentPageMetadataUserEditComment | undefined {
  const text = args.text.trim()
  const createdBy = args.createdBy.trim()
  if (text === '' || createdBy === '') return undefined
  return {
    text,
    created_by: createdBy,
    created_at: args.createdAt,
  }
}

export function pageMetadataUserEditCommentsForCreate(
  text: string | undefined,
  createdBy: string,
  createdAt: string
): DocumentPageMetadataUserEditComment[] | undefined {
  if (text === undefined) return undefined
  const comment = buildPageMetadataUserEditComment({
    text,
    createdBy,
    createdAt,
  })
  if (comment === undefined) return undefined
  return [comment]
}

export function appendPageMetadataUserEditComments(
  existing: readonly DocumentPageMetadataUserEditComment[] | null | undefined,
  comment: DocumentPageMetadataUserEditComment
): DocumentPageMetadataUserEditComment[] {
  return [...(existing ?? []), comment]
}
